import { render, staticRenderFns } from "./MealBreakError.vue?vue&type=template&id=07c95a84&"
import script from "./MealBreakError.vue?vue&type=script&lang=js&"
export * from "./MealBreakError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports